/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { AppNotification, Notification } from './@types';

import { NotificationType } from '@vaisala/rockhopper-components';

/**
 * these are predefined notifications commonly used in the app
 * use notifyById(AppNotification)
 */

const DEFAULT_TIMEOUT = 7000;

const defaultConfig = {
  closable: true,
  duration: DEFAULT_TIMEOUT,
};

export const appNotificationConfig = new Map<AppNotification, Notification>();

appNotificationConfig.set(AppNotification.NetworkLost, {
  ...defaultConfig,
  type: NotificationType.Alarm,
  // localization key
  content: 'notification.network_unavailable',
  duration: 2000,
});
appNotificationConfig.set(AppNotification.SessionInvalidated, {
  ...defaultConfig,
  type: NotificationType.Alarm,
  // localization key
  content: 'notification.session_invalidated',
  duration: 2000,
});
appNotificationConfig.set(AppNotification.UploadRunning, {
  ...defaultConfig,
  type: NotificationType.Info,
  // localization key
  content: "Upload Running",
  duration: 2000,
});
appNotificationConfig.set(AppNotification.UploadFinished, {
  ...defaultConfig,
  type: NotificationType.Ok,
  // localization key
  content: "Upload Finished",
  duration: 2000,
});
appNotificationConfig.set(AppNotification.UploadError, {
  ...defaultConfig,
  type: NotificationType.Alarm,
  // localization key
  content: "Error during upload",
  duration: 2000,
});
appNotificationConfig.set(AppNotification.ReconstructionRunning, {
  ...defaultConfig,
  type: NotificationType.Info,
  // localization key
  content: "Reconstruction Running",
  duration: 2000,
});
appNotificationConfig.set(AppNotification.ReconstructionFinished, {
  ...defaultConfig,
  type: NotificationType.Ok,
  // localization key
  content: "Reconstruction Finished",
  duration: 2000,
});
appNotificationConfig.set(AppNotification.ReconstructionError, {
  ...defaultConfig,
  type: NotificationType.Alarm,
  // localization key
  content: "Error during reconstruction",
  duration: 2000,
});
